var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},_vm._l((_vm.groups),function(g,i){return _c('div',{key:'g' + g.id},[(i != 0)?_c('hr'):_vm._e(),_c('articles-box',{attrs:{"group":g.txtid,"onlyavailable":false}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }